<template>
  <div class="showEdg Radius">
    <comBox>
      <template v-slot:name>
        <h4>{{item.name}}</h4>
      </template>
      <template v-slot:content>
        <p>{{item.num}}</p>
        <p>{{$store.state.module1.isChina?'当前在线':'online'}}{{item.num}}个</p>
        <div class="showEdg-icon">
          <img :src="item.url">
        </div>
      </template>
    </comBox>
  </div>
</template>
<script>
import comBox from '../comBox/comBox.vue'
export default {
  name: 'showEdg',
  components: {
    comBox
  },
  props: ['item']
}
</script>

<style scoped>
.showEdg{
    width:3.54rem;
    height:1.56rem;
    background:white;
    position:relative;
    overflow:hidden;
}
.showEdg p{
    text-align:left;
}
.showEdg p:nth-child(1){
    margin-top:0.05rem;
    margin-bottom:0.1rem;
    height: 0.48rem;
    font-size: 0.32rem;
font-weight: 600;
color: #1d2d4e;
line-height: 0.48rem;
}
.showEdg p:nth-child(2){
height: 0.2rem;
opacity: 0.5;
font-size: 0.14rem;
font-weight: 400;
color: #1d2d4e;
line-height: 0.2rem;
}
.showEdg-icon{
position:absolute;height:0.66rem;
width:0.66rem;
top:0.24rem;
right:0.32rem;
border-radius:40%;
overflow:hidden;
}
</style>
